<template>
  <div>
    <template v-if="varCategories !== null">
      <table class="settings">
        <thead>
          <tr>
            <td class="switch"></td>
            <td>имя</td>
            <td>описание</td>
            <td style="min-width: 140px;">редактируемое <a
                href="https://www.procollege.ru/mod/page/view.php?id=203#hideCategory" target="_blank">
                <v-icon class="mb-4 text-black">mdi-chat-question</v-icon>
              </a>
            </td>
            <td style="min-width: 170px;">показать значение <a
                href="https://www.procollege.ru/mod/page/view.php?id=203#hideCategory" target="_blank">
                <v-icon class="mb-4 text-black">mdi-chat-question</v-icon>
              </a></td>
            <td style="min-width: 160px;">включить в приказ <a
                href="https://www.procollege.ru/mod/page/view.php?id=203#hideCategory" target="_blank">
                <v-icon class="mb-4 text-black">mdi-chat-question</v-icon>
              </a></td>
          </tr>
        </thead>
      </table>

      <div v-for="vCat in varCategories" :key="vCat.title">
        <table>
          <tbody>
            <tr v-on:click="toggleCat(vCat)" class="pointer">
              <td class="switch">
                <div>
                  <img v-if="!vCat.show" :src="$model.wwwroot +
                    '/blocks/manage_groups/lib/plus-square.svg'
                    " />
                  <img v-else :src="$model.wwwroot +
                    '/blocks/manage_groups/lib/minus-square.svg'
                    " />
                </div>
              </td>
              <td colspan="3">{{ vCat.title }}</td>
            </tr>
          </tbody>
        </table>

        <div v-if="vCat.show">
          <div v-for="(vr, index) in vCat.variables" :key="vr.id">
            <table>
              <tbody>
                <tr :style="{
                  backgroundColor: index % 2 == 0 ? '#EAEAEA' : 'transparent',
                }">
                  <td class="switch"></td>
                  <td>
                    {{ vr.name }}
                    <v-icon title="фильтр" class="edit-icon" v-if="vr.options && vr.options.filter"
                      @click="editFilterDialog(vr)">
                      mdi-filter
                    </v-icon>
                  </td>
                  <td>{{ vr.description }}</td>
                  <td style="min-width: 140px;" v-on:click="toggleEditableVar(vr)" class="params">
                    <div v-if="vr.canedit && vr.editable" style="color: green">
                      Да
                    </div>
                    <div v-else>Нет</div>
                  </td>
                  <td style="min-width: 170px;" v-on:click="toggleViewableVar(vr)" class="params">
                    <div class="inline" v-if="vr.viewable" style="color: green">
                      Да
                    </div>
                    <div class="inline" v-else>Нет</div>
                  </td>
                  <td style="min-width: 160px;" v-on:click="toggleRequireVar(vr)" class="params">
                    <div v-if="vr.require" style="color: green">Да</div>
                    <div v-else>Нет</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <v-skeleton-loader type="article"></v-skeleton-loader>
    </template>
    <!-- dialogs -->
    <v-dialog v-model="filterDialog" width="600">
      <v-card>
        <v-card-title class="grey lighten-4">Фильтр: {{ filter.name }}</v-card-title>

        <v-card-text>
          <div class="filterDialog">
            <v-autocomplete variant="outlined" item-title="value" item-value="key" clearable multiple
              v-model="filter.selected" return-object :items="filter.options"></v-autocomplete>
          </div>
          <p>После утверждения изменить на:</p>
          <div class="filterDialog" style="height: 200px">
            <v-autocomplete variant="outlined" item-title="value" item-value="key" clearable v-model="filter.set"
              return-object :items="filter.options"></v-autocomplete>
          </div>
        </v-card-text>

        <v-card-actions class="grey lighten-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="filterDialog = false">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      varCategories: null, //глобальные переменные: данные студента и проч
      filter: [],
      filterDialog: false,
      viewableDialog: false,
      //все переменные из категории данных студента/родителей требуют
      //student-list. Заполним при получении данных
      requireDependencies:
      //если нужен список студентов, нужен и фильтр по статусу, это основной фильтр, помимо фильтра по группам
      //пол в любом случае в печати для склонения нужен
      //ФИО естессно
      //и номер группы для фильтрации,даже если в печати не нужна
      {
        'student-list': [
          'student-gender',
          'student-status',
          'student-lastname',
          'student-name',
          'student-patronymic',
          'student-group'
        ],
        'student-spec-name': [
          'student-spec-code'
        ],
        'student-spec-code': [
          'student-spec-name'
        ],
      }
    };
  },
  props: {
    categoryid: false,
    saved: Boolean,
  },
  created() {
    this.axios
      .post(
        this.$model.wwwroot + "/procollege/manage_groups/documents3/categoriesGetAllVariables",
        new URLSearchParams({
          categoryid: this.categoryid,
        })
      )
      .then((response) => {
        this.settingsLoaded(response.data);
      })
      .catch((error) => {
        this.axiosDefaultErrorHandler(error);
      });

    this.$eventBus.$on("save-category", (categoryid) => {
      this.varCategories.catalogid = this.$route.params.id;
      let data = JSON.stringify(this.varCategories);
      if (categoryid == undefined) {
        categoryid = this.categoryid;
      }

      this.axios
        .post(
          this.$model.wwwroot + "/procollege/manage_groups/documents3/categoriesSaveDefaultVar",
          new URLSearchParams({
            id: categoryid,
            data: data,
          })
        )
        .then((response) => {
          this.$emit("update:saved", true);
        })
        .catch((error) => {
          this.axiosDefaultErrorHandler(error);
        });


    });

    this.$emit("update:saved", false);
  },
  beforeUnmount(){
    this.$eventBus.$off("save-category");
  },
  methods: {
    settingsLoaded(resp) {
      this.varCategories = resp;

      for (let key in this.varCategories) {
        //все переменные из категории данных студента/родителей требуют
        //student-list
        if (["personal", "parents", "education"].includes(key)) {
          this.varCategories[key].variables.forEach(element => {
            if (this.requireDependencies[element.name] == undefined) {
              this.requireDependencies[element.name] = ["student-list"];
            }
            else {
              this.requireDependencies[element.name].push("student-list");
            }
          });
        }
      }

      this.setRequireDependencies();

      for (let key in this.varCategories) {
        //раскрыть категорию, если хоть 1 переменная выбрана
        this.varCategories[key].variables.forEach(element => {
          element.require = parseInt(element.require)
          element.editable = parseInt(element.editable)
          element.canedit = parseInt(element.canedit)
          element.viewable = parseInt(element.viewable)
          if (element.require || element.editable || element.viewable) {
            this.varCategories[key].show = true;
          }
        });
      }

    },
    setRequireDependencies(varName) {
      for (let keyDep in this.requireDependencies) {
        if (varName != undefined && keyDep != varName) {
          continue;
        }
        let dependenceVar = null;
        for (let category in this.varCategories) {
          this.varCategories[category].variables.forEach(variable => {
            if (variable.name == keyDep) {
              dependenceVar = variable;
            }
          })
        }

        if (!dependenceVar.require) {
          continue;
        }

        for (let category in this.varCategories) {
          this.varCategories[category].variables.forEach(variable => {
            if (this.requireDependencies[keyDep].includes(variable.name) && !variable.require) {
              variable.require = 1;
              if (this.requireDependencies[variable.name] != undefined) {
                this.setRequireDependencies(variable.name);
              }
            }
          })
        }
      }
    },
    toggleRequireVar: function (vr) {
      vr.require = !vr.require;
      if (!vr.require) {
        vr.editable = false;
        vr.viewable = false;
        if (this.requireDependencies[vr.name] != undefined) {
          this.requireDependencies[vr.name].forEach(dependencyName => {
            for (let category in this.varCategories) {
              this.varCategories[category].variables.forEach(variable => {
                if (variable.name == dependencyName) {
                  variable.require = false;
                  variable.editable = false;
                  variable.viewable = false;
                }
              })
            }
          })
          for (let varName in this.requireDependencies) {
            if (this.requireDependencies[varName].includes(vr.name)) {
              for (let category in this.varCategories) {
                this.varCategories[category].variables.forEach(variable => {
                  if (variable.name == varName) {
                    variable.require = false;
                    variable.editable = false;
                    variable.viewable = false;
                  }
                })
              }
            }
          }
        }
      }

      this.setRequireDependencies();
    },
    toggleEditableVar: function (vr) {
      vr.editable = !vr.editable && vr.canedit;
      if (vr.editable) {
        vr.require = true;
        vr.viewable = true;
      }
      this.setRequireDependencies();
    },
    toggleViewableVar: function (vr) {
      vr.viewable = !vr.viewable;
      if (vr.viewable) {
        vr.require = true;
      }
      this.setRequireDependencies();
    },
    toggleCat: function (vCat) {
      vCat.show = !vCat.show;
    },
    editFilterDialog(vr) {
      this.filter = vr.options.filter;
      this.filterDialog = true;
    },
  },
};
</script>

<style scoped>
table {
  width: 100%;
  border-spacing: 0;
  color: #000;
  margin-top: 5px;
}

table>thead {
  background: #e4e9ee;
}

td {
  color: black;
  padding: 10px 5px;
  border-left: 1px solid #ffffff;
  border-right: none;
  color: dimgray;
}

td:nth-child(2) {
  width: 160px;
  min-width: 160px;
}

td:nth-child(3) {
  width: 100%;
}

td.switch {
  min-width: 12px;
  width: 12px;
  text-align: center;
  display: table-cell;
}

td.switch div {
  width: 11px;
}

td.params {
  cursor: pointer;
}

.filterDialog {
  margin-top: 20px;
}

.pointer {
  cursor: pointer;
}

.edit-icon {
  cursor: pointer;
  float: right;
}

.inline {
  display: inline;
}
</style>
